import { useEffect, useState } from "react";
import axios from "axios";
import { Instagram } from "lucide-react";
import { API, LINKS } from "../data/site";
import { FadeUp } from "./Motion";

const KITCHEN_WALL = [
  { src: "/images/dishes/ghee-masala-dosa.jpg", label: "Ghee Masala Dosa" },
  { src: "/images/dishes/veg-noodles.jpg", label: "Veg Noodles" },
  { src: "/images/dishes/chat.jpg", label: "Chat — Burst of Flavors" },
  { src: "/images/dishes/idli.jpg", label: "Idli" },
  { src: "/images/dishes/sambar-idli.jpg", label: "Sambar Idli" },
  { src: "/images/dishes/pani-puri.jpg", label: "Pani Puri" },
  { src: "/images/dishes/sev-puri.jpg", label: "Sev Puri" },
  { src: "/images/dishes/dahi-puri.jpg", label: "Dahi Puri" },
  { src: "/images/dishes/samosa-chat.jpg", label: "Samosa Chat" },
];

const InstagramFeed = () => {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/instagram/feed?limit=8`)
      .then((r) => { setPosts(r.data.data || []); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, []);

  if (!loaded) return null;

  return (
    <div className="mt-20" data-testid="instagram-feed">
      <FadeUp>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <h3 className="font-serif text-3xl text-white md:text-4xl">
            Fresh off the <em className="italic text-gold">tawa</em> — @sridosaexpress
          </h3>
          <a
            href={LINKS.instagram}
            target="_blank"
            rel="noreferrer"
            data-testid="ig-follow-link"
            className="btn-ghost flex items-center gap-2 rounded-full px-5 py-2.5 text-[11px] uppercase tracking-[0.18em] text-white/80"
          >
            <Instagram size={14} className="text-gold" /> Follow us
          </a>
        </div>
      </FadeUp>

      {posts.length > 0 ? (
        <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4" data-testid="ig-posts-grid">
          {posts.map((p) => (
            <a
              key={p.id}
              href={p.permalink}
              target="_blank"
              rel="noreferrer"
              data-testid={`ig-post-${p.id}`}
              className="group relative aspect-square overflow-hidden rounded-xl border border-white/10"
            >
              <img
                src={p.image_url}
                alt={p.caption || "Sri Dosa Express on Instagram"}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 flex items-end bg-gradient-to-t from-ink/85 via-transparent to-transparent p-4 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                <p className="line-clamp-3 text-xs leading-relaxed text-white/85">{p.caption || "View on Instagram"}</p>
              </div>
            </a>
          ))}
        </div>
      ) : (
        <div className="mt-8 columns-2 gap-4 md:columns-4 [column-fill:_balance]" data-testid="kitchen-wall">
          {KITCHEN_WALL.map((d, i) => (
            <FadeUp key={d.src} delay={(i % 4) * 0.07} className="mb-4 break-inside-avoid">
              <figure data-testid={`kitchen-${d.src.split("/").pop().replace(".jpg", "")}`} className="group relative overflow-hidden rounded-xl border border-white/10">
                <img
                  src={d.src}
                  alt={d.label}
                  loading="lazy"
                  className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </figure>
            </FadeUp>
          ))}
        </div>
      )}
    </div>
  );
};

export default InstagramFeed;
